// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 268 ? "d62f3d88" : chunkId) + "." + {"268":"074293a184110649","946":"3934ce802d4cc98d"}[chunkId] + ".js";
};